import { useQuery } from "@tanstack/react-query";
import type { UseQueryOptions } from "@tanstack/react-query";

import type { ProviderProfile, UUID } from "@/core/types";
import { SHORT_LIVED_CACHE } from "@/lib/constants/cache";

import { getProviderProfile } from "../queryFunctions/getProviderProfile";
import { providerProfileKeys } from "../keyFactory";

type ProviderProfileQueryOptions = UseQueryOptions<
  ProviderProfile,
  unknown,
  ProviderProfile,
  ReturnType<typeof providerProfileKeys.details>
>;

function optionFactory(providerId?: UUID) {
  return {
    queryFn: () => getProviderProfile(providerId),
    queryKey: providerProfileKeys.details(providerId),
    staleTime: SHORT_LIVED_CACHE,
  } satisfies ProviderProfileQueryOptions;
}

export function useProviderProfile(providerId?: UUID) {
  return useQuery(optionFactory(providerId));
}
